import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import Row from 'react-bootstrap/Row'; import { MenuLateral } from '../MenuLateral/MenuLateral'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilePdf } from '@fortawesome/free-solid-svg-icons'; // Importa el icono faBars
import Nav from 'react-bootstrap/Nav';
import { fichaCH42tn, fichaSC95tn, fichaDS60tn, certificadoSC95tn, certificadoDS60tn } from '../../Archivos/altavocesTecho';
import './AltavocesTecho.css';

export function AltavocesTecho() {

    const [fotoSeleccionada, setFotoSeleccionada] = useState(null);
    const [subtituloModal, setSubtituloModal] = useState("");

    const modalFoto = (foto, subtitulo) => {
        setFotoSeleccionada(foto);
        setSubtituloModal(subtitulo)
    };

    const logoPdf = <FontAwesomeIcon icon={faFilePdf} size="xl" style={{ color: "#006c87", }} />

    const abrirPdf = (archivo) => {
        window.open(archivo, '_blank');
    };

    const archivosPDF = {
        fichaCH42tn: fichaCH42tn,
        fichaSC95tn: fichaSC95tn,
        fichaDS60tn: fichaDS60tn,
        certificadoSC95tn: certificadoSC95tn,
        certificadoDS60tn: certificadoDS60tn

    };

    const clicEnlacePdf = (tipoArchivo) => {
        abrirPdf(archivosPDF[tipoArchivo]);
    };

    return (
        <>
            <div className="mainContainer">
                <MenuLateral />

                <div className='contenedorProducto'>
                    <div className='row'>
                        <div className='col-xl-3 col-lg-3 col-md-12 col-sm-12'>
                            <div className='imagenesAltavocesTecho'>

                                <Row>
                                    <div className='contenedorFoto' >
                                        <img className="imagenProductoAltavocesTecho"
                                            src={require("../Img/ch-42tn.webp")}
                                            
                                            onClick={() => modalFoto(require("../Img/ch-42tn.webp"), 'CH-42TN')}
                                            alt='CH-42tn' />
                                    </div>
                                </Row>
                                <Row>
                                    <div className='contenedorFoto' >
                                        <img className="imagenProductoAltavocesTecho"
                                            src={require("../Img/sc-95tn.webp")}
                                            
                                            onClick={() => modalFoto(require("../Img/sc-95tn.webp"), 'SC-95TN')}
                                            alt='SC-95tn' />
                                    </div>
                                </Row>
                                <Row>
                                    <div className='contenedorFoto' >
                                        <img className="imagenProductoAltavocesTecho"
                                            src={require("../Img/ds-60tn.webp")}
                                            
                                            onClick={() => modalFoto(require("../Img/ds-60tn.webp"), 'DS-60TN')}
                                            alt='DS-60tn' />
                                    </div>
                                </Row>

                            </div>
                        </div>
                        <div className='col-xl-6 col-lg-6 col-md-12 col-sm-12'>
                            <div className='descripcionAltavocesTecho'>
                                <h2 className='nombreProductoAltavocesTecho'>Altavoces de techo o superficie</h2>
                                <h5 className='tituloProductoAltavocesTecho'>Altavoz de techo CH-42TN
                                </h5>
                                <p className='textoProductoAltavocesTecho'>
                                    El altavoz de techo EN 54-24 de 5″ para líneas de 70/100V que proporciona la protección necesaria para que en caso de
                                    fuego, los daños en el altavoz no causen fallos en el circuito de altavoces al que estén conectados.
                                    <br /><br />
                                    Manteniendo de esta forma la integridad del sistema al asegurar que los altavoces estan siguen conectados al mismo
                                    circuito y así poder seguir emitiendo los mensajes de alerta.

                                </p>

                                <h5 className='tituloProductoAltavocesTecho'> Altavoz coaxial de techo SC-95TN
                                </h5>
                                <p className='textoProductoAltavocesTecho'>
                                    El SC-95TN es un altavoz coaxial de techo de 24W de alto rendimiento. Su amplio rango de frecuencia, baja distorsión
                                    y alto nivel de presión sonora proporcionan un sonido e Inteligibilidad de voz excelentes. Su moderno perfil bajo y
                                    diseño en rojo y blanco hacen que combine fácilmente en la mayoría de las instalaciones, como hoteles, centros
                                    comerciales, salas de conferencia o centros de exhibiciones.
                                    <br /><br />
                                    Este altavoz cumple con la normativa para alarma por voz EN54-24 que asegura que, en caso de incendio, los daños en
                                    el altavoz no provocan fallos en el circuito al que está conectado.

                                </p>
                                <h5 className='tituloProductoAltavocesTecho'> Altavoz de superficie DS-60TN
                                </h5>
                                <p className='textoProductoAltavocesTecho'>
                                    Altavoz de 4” de superficie de 6W fabricado en metal. Su diseño en blanco permite mimetizarse con la mayoría de 
                                    espacios y es un altavoz ideal para distribución de sonido en diversos tipos de instalaciones como centros comerciales, 
                                    hoteles, salas de conferencias, cines, fábricas, salas de exposiciones, etc.
                                    
                                </p>
                            </div>
                        </div>
                        <div className='col-lg-3 col-md-12'>

                            <div className='contenedorNavAltavocesTecho'>
                                <Nav as="ul" className="flex-column">
                                    <Nav.Item className='linksArchivosAltavocesTecho' as="li" onClick={() => clicEnlacePdf('fichaCH42tn')}>
                                        {logoPdf}
                                        Ficha VAP-1
                                    </Nav.Item>
                                    <Nav.Item className='linksArchivosAltavocesTecho' as="li" onClick={() => clicEnlacePdf('fichaSC95tn')}>
                                        {logoPdf}
                                        Ficha VAP-8K
                                    </Nav.Item>
                                    <Nav.Item className='linksArchivosAltavocesTecho' as="li" onClick={() => clicEnlacePdf('fichaDStn')}>
                                        {logoPdf}
                                        Ficha Rack 4
                                    </Nav.Item>
                                    <Nav.Item className='linksArchivosAltavocesTecho' as="li" onClick={() => clicEnlacePdf('certificadoSC95tn')}>
                                        {logoPdf}
                                        Ficha Rack 6
                                    </Nav.Item>
                                    <Nav.Item className='linksArchivosAltavocesTecho' as="li" onClick={() => clicEnlacePdf('certificadoDS60tn')}>
                                        {logoPdf}
                                        Manual VAP-1
                                    </Nav.Item>

                                </Nav>
                            </div>
                        </div>
                    </div>

                </div>

            </div>

            <Modal className='imgModalContainer' show={fotoSeleccionada !== null} onHide={() => setFotoSeleccionada(null)}>
                <Modal.Header closeButton>
                    {subtituloModal && <Modal.Title>{subtituloModal}</Modal.Title>}
                </Modal.Header>
                <Modal.Body>
                    {fotoSeleccionada && (<img src={fotoSeleccionada} alt="Foto Altavoces de techo o superficie" className="imgModal" />)}
                </Modal.Body>
            </Modal>

        </>
    );

}

